module.exports = __webpack_public_path__ + "img/2.b7fd51ff.jpg";